import { createContext } from 'react';

import { HeaderInterface, DefaultInterface } from '../../models/services/header-interface';

const HeaderContext = createContext<HeaderInterface>(DefaultInterface);

export { HeaderContext };